import React from "react";
import { WHY } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export default function WhyChoose() {
  return (
    <section id="about" data-testid="why-choose" className="relative py-12 md:py-16 noise">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-20">
              <Reveal>
                <Overline>Why VynFive</Overline>
                <h2 className="mt-5 font-heading text-4xl md:text-5xl font-bold tracking-tight leading-tight">
                  An engineering-first culture, <span className="text-gradient">not a vendor</span>
                </h2>
                <p className="mt-6 text-textsub leading-relaxed">
                  We combine senior talent, automation and cloud-native rigour to deliver
                  systems that scale, stay secure and keep you ahead. Six principles guide
                  every engagement.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-line rounded-2xl overflow-hidden border border-line">
            {WHY.map((w, i) => (
              <Reveal key={w.n} delay={(i % 2) * 0.08} className="h-full">
                <div className="group h-full bg-bg p-6 hover:bg-surface transition-colors duration-500">
                  <span className="font-mono text-5xl font-bold text-line group-hover:text-gradient transition-all duration-500 block">
                    {w.n}
                  </span>
                  <h3 className="mt-5 font-heading text-xl font-semibold tracking-tight">{w.title}</h3>
                  <p className="mt-3 text-sm text-textsub leading-relaxed">{w.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
